import { Mimshak } from "../interfaces/DTO/mislaka_xml_models";

// יצרנים שמדווחים את קוד הסוכן גם כשהסוכן לא באמת מקבל עליה עמלה – אנליסט ומיטב
export const AGENT_CODE_ALWAYS_REPORTED_HANDLER_CODES = new Set([
  "511880460", // אנליסט
  "512065202", // מיטב
]);

// מינוי הסוכן מאוחר ביותר מ-40 יום מההצטרפות למוצר – ההנחה שהפוליסה לא ברשות הסוכן
const MAX_DAYS_FROM_JOIN_TO_APPOINTMENT = 40;
const DAY_MS = 1000 * 60 * 60 * 24;

const parseDate = (value?: string | null): Date | null => {
  if (!value) return null;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
};

/**
 * אנליסט / מיטב: קוד הסוכן מדווח תמיד, ולכן בודקים את התאריכים –
 * אם הסוכן מונה יותר מ-40 יום אחרי ההצטרפות למוצר, מניחים שהפוליסה לא ברשות הסוכן.
 */
export const isAppointedLongAfterProductJoin = (row: {
  handler_code?: string | null;
  agent_appointment_date?: string | null;
  data?: Mimshak | null;
}): boolean => {
  if (!AGENT_CODE_ALWAYS_REPORTED_HANDLER_CODES.has(row.handler_code ?? "")) return false;
  // תאריך ההצטרפות למוצר בלבד – join_date הוא תאריך פתיחת הפוליסה ואינו רלוונטי כאן
  const productJoinDate = parseDate(row.data?.products?.[0]?.policies_or_accounts?.[0]?.product_join_date);
  const appointmentDate = parseDate(row.agent_appointment_date);
  if (!productJoinDate || !appointmentDate) return false;
  return (appointmentDate.getTime() - productJoinDate.getTime()) / DAY_MS > MAX_DAYS_FROM_JOIN_TO_APPOINTMENT;
};
